export const coreSettingsErrors = {
    restartAttempts(state: any) {
        if (state?.restart_attempts < 0) {
            return {
                message: 'errors.validation.greaterOrEqual',
                values: { greaterOrEqual: 0 },
            }
        }
    },
    restartDelaySec(state: any) {
        if (state?.restart_delay_sec < 0) {
            return {
                message: 'errors.validation.greaterOrEqual',
                values: { greaterOrEqual: 0 },
            }
        }
    },
    backupIntervalDays(state: any) {
        if (state?.backup_interval_days < 0) {
            return {
                message: 'errors.validation.greaterOrEqual',
                values: { greaterOrEqual: 0 },
            }
        }
    },
    storageLimitGb(state: any) {
        if (state?.storage_limit_gb < 0) {
            return {
                message: 'errors.validation.greaterOrEqual',
                values: { greaterOrEqual: 0 },
            }
        }
    },
    lifetimeDays(state: any) {
        if (state?.lifetime_days < 0) {
            return {
                message: 'errors.validation.greaterOrEqual',
                values: { greaterOrEqual: 0 },
            }
        }
    },
    retryAttempts(state: any) {
        if (state?.restart_delay_sec < 0) {
            return {
                message: 'errors.validation.greaterOrEqual',
                values: { greaterOrEqual: 0 },
            }
        }
    },
    retryDelaySecBackup(state: any) {
        if (state?.restart_delay_sec < 0) {
            return {
                message: 'errors.validation.greaterOrEqual',
                values: { greaterOrEqual: 0 },
            }
        }
    },
}
